<script>
    import { onMount } from "svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import Card from "../components/card.svelte";
    import Spinner from "../components/spinner.svelte"; 
    import DataTable from "../../components/data-table.svelte";

    export let providerId; 

    let users = [];
    let isPageLoading;
    let columnDefs = [{ type: 'date-euro', targets: [2] }];

    onMount(async () => {
        await getUsersList();  
    });

    const getUsersList = async () => {

        isPageLoading = true;
        
        let resp = await wrappedFetch(`/api/cloudConfig/GetNimbusCreatedUsers?providerId=${providerId}`, {
            method: "post",
        });
        
        users = await resp.json();
        
        isPageLoading = false;

    };

    let order = [[2, "desc"]]

</script>

<svelte:head>
    <title> New Users | Wavenet Nimbus </title>
</svelte:head>

<div class="row">
    <div class="col-12">
        <a class="btn btn-grey mb-3" href="/app/export/{providerId}/detailedLogs"><i
                class="fas fa-arrow-left" />
            Back</a>
    </div>
</div>

<h1>Users created by Nimbus</h1>
<p>These users had new accounts created by the sync. Please <a href="/api/cloudConfig/DownloadNewUsers?providerId={providerId}">click here</a> to download the full details for all users.</p>

{#if isPageLoading}
    <Spinner />
{:else}
    {#if providerId > 0}
    <Card>
        <div slot="body">
            <!-- <div class="form-group">
                <div class="row" style="display: contents;">
                    <div style="text-align:right;">
                        <a href="/api/cloudConfig/DownloadNewUsers?providerId={providerId}" class="btn btn-primary" style="cursor:default;">
                            <span style="display:flex;">
                                <span class="material-icons-outlined">file_download</span>
                                &nbsp; Download users
                            </span>
                        </a>
                    </div>
                </div>
            </div> -->
            <DataTable {columnDefs} {order} DataLength={users.length} ResponsiveHeader='0,1' message="No new users were created during sync.">
                <thead>
                    <tr>
                        <th>Name </th>
                        <th>Email</th>
                        <th>Create On</th>
                        <!-- <th>Password</th> -->
                    </tr>
                </thead>
                <tbody>
                    {#each users as user}                
                    <tr>
                        <td>{user.name}</td>
                        <td>{user.cloudEmail}</td>
                        <td>{user.createdOn}</td>
                    </tr>
                    {/each}
                </tbody>
            </DataTable>
        </div>
    </Card>
    {/if}
{/if}